/**
 * @prettier
 * @flow
 */
export function alertKnownErrorOrSomethingWentWrong(response: any): void {
    if (!response) {
        alert('Something went wrong');
        return;
    }
    if (response.status === 401) {
        // handled already in createPaymentLinkApi by setting error message in reducer state, so here just ignore
        // alert(`Singed out since have been signed in for too long.\nPlease sign in again.`)
        return;
    }
    if (response?.data?.message) {
        alert(response.data.message);
        return;
    }
    alert(`Something went wrong (${response.status ?? ''}: ${response.problem ?? ''})`);
}
